import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from "vue-ext";
import { getOrderRowPrice, getExtraServiceTranslationKey } from "./utils";
var OrderCreateView = /** @class */ (function (_super) {
    __extends(OrderCreateView, _super);
    function OrderCreateView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.difficultLocationProductId = "05ACC703-39E6-4E06-802C-2302C33A64BD".toLowerCase();
        _this.message = "";
        _this.weeeOrderCreateRequest = null;
        _this.weeeProductsAndQuantity = [];
        _this.getOrderRowPrice = getOrderRowPrice;
        _this.getExtraServiceTranslationKey = getExtraServiceTranslationKey;
        return _this;
    }
    OrderCreateView.prototype.routed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataLayer, eventName;
            return __generator(this, function (_a) {
                this.weeeOrderCreateRequest = this.$customerOrderStore.getWeeeOrderCreateRequest();
                this.weeeProductsAndQuantity = this.$customerOrderStore.getWeeeOrderItems();
                this.$customerOrderStore.removeWeeeOrderCreateRequest();
                this.$customerOrderStore.removeWeeeOrderItems();
                try {
                    dataLayer = window.dataLayer;
                    if (dataLayer) {
                        eventName = "";
                        if (this.weeeOrderCreateRequest.direction === "Retrieve") {
                            eventName = "weee_retrieve_order_complete";
                        }
                        else if (this.weeeOrderCreateRequest.direction === "Deliver") {
                            eventName = "weee_deliver_order_complete";
                        }
                        else {
                            eventName = "weee_undefined_order_complete";
                        }
                        dataLayer.push({ "event": eventName, "eventCategory": "Weee" });
                    }
                }
                catch (err) {
                    console.log(err);
                }
                return [2 /*return*/];
            });
        });
    };
    OrderCreateView.prototype.getDisplayName = function (item) {
        var selectedService = item.extraServices.find(function (s) { return s.isSelected === true; });
        if (!selectedService) {
            return item.product.name;
        }
        var serviceKey = getExtraServiceTranslationKey(selectedService, item.product);
        var key = serviceKey + ".summaryDisplayName";
        var altDisplayName = this.$t(key);
        // If alternate display name not found
        if (altDisplayName == key) {
            var additionalInfoKey = serviceKey + ".summaryInputLabel";
            var additionalInfo = this.$t(additionalInfoKey);
            return item.product.name + " - " + additionalInfo;
        }
        return altDisplayName;
    };
    Object.defineProperty(OrderCreateView.prototype, "total", {
        get: function () {
            var _this = this;
            var sum = 0;
            this.weeeProductsAndQuantity.forEach(function (p) {
                if (p.product.weeeProductId == _this.difficultLocationProductId) {
                    return;
                }
                sum += getOrderRowPrice(p);
            });
            return sum;
        },
        enumerable: false,
        configurable: true
    });
    OrderCreateView = __decorate([
        Component
    ], OrderCreateView);
    return OrderCreateView;
}(Vue));
export default OrderCreateView;
